// extracted by mini-css-extract-plugin
export default {"files":"policy_files__Jf0nW","text":"policy_text__7RoNu","pdf_icon":"policy_pdf_icon__dfTub","button":"policy_button__B5qUK"};